import {
    getAnimTypeByPlayMode,
} from '../utils';
import {
    PLAY_MODE,
} from '@src/js/js-keyframe-animation/style-converter/constants';
import { AnimType } from '@tencent/slide-sdk-model';
export const getOpacityByPlayMode = (timeNode, playMode) => {
    if (playMode === PLAY_MODE.edit) {
        return (100 - (timeNode?.props?.opacityValue || 0)) / 100;
    }
    const { anim: { childTnLst = [] } = {} } = timeNode;
    let opacityValue = 1;
    childTnLst.forEach((item) => {
        if (item?.type === 'tn_set') {
            opacityValue = Number(item?.to?.toStrVal || 1);
        }
    });

    return opacityValue;
};
export const getEmphOpacityToStyle = (timeNode, playMode) => {
    const animType = getAnimTypeByPlayMode(timeNode, playMode);
    if (animType !== AnimType.EmphTransparency) return {};
    return { opacity: getOpacityByPlayMode(timeNode, playMode) };
};
